import React, {Component} from "react";
import {ROOM_DETAIL_URL, CANCEL_RESERVE_URL, RESERVE_RESULT_LINK} from "../actions/types.js";
import BackToUpperLevel from "./BackToUpperLevel.js";
// import Button from '@material-ui/core/Button';
import IconCount from "../images/icon_count.svg";

// import IconVideo from "../images/icon_video_black.svg";
// import IconLaptop from "../images/icon_laptop_black.svg";
// import IconBlackboard from "../images/icon_blackboard_black.svg";
// import Iconspeaker from "../images/icon_speaker_black.svg";

import IconVideo from "../images/room/video.svg";
import IconLaptop from "../images/room/laptop.svg";
import IconBlackboard from "../images/room/blackboard.svg";
import Iconspeaker from "../images/room/audio.svg";
import Iconscreen from "../images/room/screen.svg";

import axios from "axios";
import moment from "moment";
import "moment/locale/zh-cn";
import alert from "antd-mobile/lib/modal/alert";

moment.locale("zh-cn");

class MyReserveDetail extends Component {
  state = {
    myReserve: {},
    room: {},
    isPassed: false
  };

  componentDidMount() {
    const {id} = this.props.match.params;
    if (id) {
      axios({
        method: "get",
        url: `${ROOM_DETAIL_URL}/${id}`,
      }).then(res => {
        this.setState({room: res.data});
        if (this.props.location.state) {
          this.setState({myReserve: this.props.location.state.data, isPassed: this.props.location.state.isPassed});
        } else {
          this.props.history.go(-1);
        }
      });
    }
  }

  cancelReserve() {
    const {myReserve} = this.state;
    if (myReserve.id) {
      axios({
        method: "get",
        url: `${CANCEL_RESERVE_URL}/${myReserve.id}`,
        headers: {
          "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
        }
      }).then(res => {
        this.props.history.push(`${RESERVE_RESULT_LINK}/canceled/${myReserve.id}`);
      });
    }
  }

  render() {
    const {myReserve, room} = this.state;
    console.log(9999, room, myReserve);
    if (myReserve.id) {
      let photoUrl = "";
      if (room.mediaList && room.mediaList.length !== 0) {
        let photoArr = room.mediaList.filter(data => {
          return data.type === "photo";
        });
        if (photoArr.length !== 0) {
          photoUrl = photoArr[0].url;
        }
      }
      return (
        <React.Fragment>
          <BackToUpperLevel title="详情" history={this.props.history}/>
          <div className="container">
            <div className="my-reserve-detail-purpose">{myReserve.purpose}</div>
            <div className="reserve-content my-reserve-detail-contain">
              <div className="reserve-left">
                <div className="reserve-area" style={{marginBottom: 8}}>
                  {room.name}
                </div>
                <div className="reserve-time" style={{marginBottom: 8}}>
                  <img src={IconCount} alt="icon" height={14} style={{marginRight: 4}}/>
                  <span>{room.capacity}人</span>
                </div>
                <div className="reserve-icon">
                  {myReserve.roomProjector_status && <img src={IconVideo} alt="icon" height={16}/>}
                  {myReserve.roomComputer_status && <img src={IconLaptop} alt="icon" height={16}/>}
                  {myReserve.roomBoard_status && <img src={IconBlackboard} alt="icon" height={16}/>}
                  {myReserve.soundDevice_status && <img src={Iconspeaker} alt="icon" height={16}/>}
                  {myReserve.videoEquipment_status && <img src={Iconscreen} alt="icon" height={16}/>}
                </div>
              </div>
              <div className="reserve-room-img" style={{backgroundImage: `url(${photoUrl})`}}/>
            </div>
            <div className="reserve-detail">
              <section className="reserve-detail-section">
                <div className="reserve-detail-title">预约时间</div>
                <div style={{fontSize: 20, lineHeight: "28px"}}>
                  {moment(myReserve.start).format("MM 月 DD 日 HH:mm")} - {moment(myReserve.end).format("HH:mm")}
                </div>
              </section>
              {/*<section className="reserve-detail-section">
								<div className="reserve-detail-title">会议名称</div>
								<div>{myReserve.purpose}</div>
							</section>*/}
              {/*<hr></hr>*/}
              <section className="reserve-detail-section">
                <div className="reserve-detail-title">会议类型</div>
                <div>{{
                  "0": "学术报告",
                  "1": "组会",
                  "2": "学生答辩",
                  "3": "学生活动",
                  "4": "党务会议",
                  "5": "学院层面业务会议",
                  "6": "其它",
                }[myReserve.meeting_type] || "无"}</div>
              </section>
              {myReserve.meeting_type === 0 && <section className="reserve-detail-section">
                <div className="reserve-detail-title">学术报告描述</div>
                <div>{myReserve.meeting_type_describe || "无"}</div>
              </section>}
              <section className="reserve-detail-section">
                <div className="reserve-detail-title">会议召集人</div>
                <div>{myReserve.convener}</div>
              </section>
              <section className="reserve-detail-section">
                <div className="reserve-detail-title">预约人</div>
                <div>{myReserve.appointment}</div>
              </section>
              <section className="reserve-detail-section">
                <div className="reserve-detail-title">预约人电话</div>
                <div>{myReserve.appointment_phone}</div>
              </section>
              {/*<hr></hr>*/}
              <section className="reserve-detail-section">
                <div className="reserve-detail-title">会议说明</div>
                <div>{myReserve.description}</div>
              </section>
              <section className="reserve-detail-section">
                <div className="reserve-detail-title">备注</div>
                <div>{myReserve.remark || "无"}</div>
              </section>
            </div>
          </div>
          {this.renderDiffStatus()}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <BackToUpperLevel title="详情" history={this.props.history}/>
          <div>loading</div>
        </React.Fragment>
      );
    }
  }

  renderDiffStatus() {
    const {myReserve, isPassed} = this.state;
    console.log(myReserve, isPassed)
    if (myReserve.status === "Dcanceled") {
      return (
        <div className="my-reserve-detail-bottom">
          <span className="my-reserve-detail-status status-fail">用户取消预约</span>
        </div>
      )
    } else if (myReserve.status === "Apending") {
      return (
        <div className="my-reserve-detail-bottom">
          <span className="my-reserve-detail-status">预约中</span>
          {!isPassed && <span className="my-reserve-detail-cancel" onClick={() => {
            this.cancelReserve()
          }}>取消预约</span>}
        </div>
      )
    } else if (myReserve.status === "Cfail") {
      return (
        <div className="my-reserve-detail-bottom">
          <span className="my-reserve-detail-status status-fail">预约失败</span>
        </div>
      )
    } else{
      return (
        <div className="my-reserve-detail-bottom">
          <span className="my-reserve-detail-status">预约成功</span>
          {!isPassed && <span className="my-reserve-detail-cancel" onClick={() => {
            this.cancelReserve()
          }}>取消预约</span>}
        </div>
      )
    }
  }
}

export default MyReserveDetail;
